import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import { fonts } from "../../../styles/variables";

export const BlogPostsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
  ::-webkit-scrollbar,
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    display: none;
  }
  ${breakpoints.smDown} {
    overflow-x: scroll;
  }
`;

export const ArrowWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: end;

  ${breakpoints.mdDown} {
    display: none;
  }
`;

export const SeeAllTextLink = styled.a<{ isWineDetailsPage: boolean }>`
  position: relative;
  top: -3px;
  margin-right: 16px;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  font-family: ${fonts.fontInterstateUltraBlack};
  display: none;

  ${breakpoints.mdUp} {
    ${(props) => props.isWineDetailsPage && "display: flex"};
  }
`;
